import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckValue, OptionValue } from '../../services/types/Misc';
import CheckBox from '../../shared/components/CheckBox';

interface Props {
  cells: OptionValue[];
  checkeds: string[];
  setCheckeds: (id: string, value: boolean) => void;
}

const OptionChecks = (props: Props) => {
  const { cells, checkeds, setCheckeds } = props;
  const { t } = useTranslation();
  const columns = cells.map((c) => ({
    id: String(c.id),
    text: t(c.text || ''),
    htmlId: `chk${c.value}`,
    checked: checkeds.indexOf(String(c.id)) !== -1,
  }));

  const columnCheck = (element: CheckValue) => (
    <CheckBox key={element.id} element={element} onChange={setCheckeds} />
  );

  return <div className="cols-container">{columns.map((c) => columnCheck(c))}</div>;
};

export default OptionChecks;
